@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  padding: 0 10px;
}

.header-item {
  font-size: 13px;
  color: @manage-item-grid--header--text-color;

  &:first-child {
    position: relative;
    left: -10px;
  }

  &:not(:last-child) {
    margin-right: 15px;
  }
}

.action-column-header {
  width: 84px;
  min-width: 84px;
}

.grid-row {
  background: @manage-item-grid--row--background-color;
  border-radius: 4px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  &:not(:last-child) {
    margin-bottom: 10px;
  }
}

.row-item {
  .truncate();
  height: 40px;
  line-height: 40px;
  font-size: 13px;
  color: @manage-item-grid--row--text-color;

  &:not(:last-child) {
    margin-right: 15px;
  }
}

.action-column-wrapper {
  display: flex;
  place-content: center flex-end;

  .action-column {
    min-width: 84px;

    > button {
      &:not(:last-child) {
        margin-right: 20px;
      }
    }
  }
}
